import once from 'lodash/once';
import numberField from './numberField';
import dynamicNumber from './dynamicNumber';
import contactPopUp from './contactPopUp';
import fiksudiiliCalc from '../pages/car/fiksudiili-calc.js';
import clickableDiv from './clickableDiv.js';
import genericCollapseGroup from './collapseGroup.js';
import genericPartialCollapseGroup from './partialCollapseGroup.js';
import elevatedContainer from './elevatedContainer.js';
import callrequestPopUp from './callrequestPopUp.js';
import sliderComponent from './sliderComponent';
import rangeSlider from './rangeSlider';
import ScrollableTabs from './scrollable-tabs';
import TertiaryDropdown from './tertiaryDropdown';
import CheckboxRange from './checkbox-range';
import InfoTooltip from './info-tooltip';
import HandleModal from './handleModal';
import LoadingIcon from './loading-icon';

// Please avoid jQuery here. Vanilla JS does wonders.
/**
 * Generic UI components functionality engine. The idea is to allow
 * rapid developement by creating a library of ready to use UI elements
 * that can simply be placed in code via mustache template, rather than
 * coding the same functionality over and over again
 * @type {Object}
 */
const generic = {
  /**
   * Init engine. Wrapped in lodash once to make sure it's not called repeatedly
   */
  init: once(() => {
    generic.initNumbers();
    numberField.init();
    dynamicNumber.init();
    fiksudiiliCalc.init();
    contactPopUp.init();
    sliderComponent.init();
    rangeSlider.init();
    genericCollapseGroup.initCollapse();
    genericCollapseGroup.initGenericShowAll();
    genericPartialCollapseGroup.initCollapse();
    clickableDiv.initDivList();
    elevatedContainer.init();
    callrequestPopUp.init();
    ScrollableTabs.init();
    TertiaryDropdown.init();
    CheckboxRange.init();
    InfoTooltip.init();
    HandleModal.init();
    LoadingIcon.init();
  }),
  /**
   * Attach an eventlistener to telephone inputs to filter non-numbers
   */
  initNumbers: () => {
    document.querySelectorAll('.input-telephone').forEach(input => {
      input.addEventListener('keypress', generic.numbersOnly);
    });
    document.querySelectorAll('.input-number').forEach(input => {
      input.addEventListener('keypress', generic.decimalsOnly);
    });
  },
  /**
   * Filters keypress events allowing only numbers to be typed
   * @param  {object} e object
   */
  numbersOnly: e => {
    const code = e.which ? e.which : e.keyCode;
    if (code > 31 && (code < 48 || code > 57)) {
      e.preventDefault();
    }
  },
  /**
   * Filters keypress events allowing only numbers and decimal separators to be typed
   * @param  {object} e object
   */
  decimalsOnly: e => {
    const code = e.which ? e.which : e.keyCode;
    if (code > 31 && (code < 44 || code > 57)) {
      e.preventDefault();
    }
  }
};

export default generic;
